export default __webpack_public_path__ + "static/media/create.5a473f0e.png";